// @ts-nocheck
import { IS_SERVER } from "@/shared/constants";

const consoleLog = console.log;
const consoleWarn = console.warn;
const consoleError = console.error;
const consoleInfo = console.info;
const consoleDebug = console.debug;

const BYPASS_LOG_PATTERN = [/^Failed to update prerender cache/];

const shouldBypassLog = (args) => {
    if (args.length === 0) {
        return false;
    }

    return IS_SERVER && BYPASS_LOG_PATTERN.some((pattern) => args[0] && pattern.test(args[0]));
};

console.log = (...args) => {
    const isBypass = shouldBypassLog(args);
    if (isBypass) {
        return;
    }

    consoleLog(...args);
};
console.warn = (...args) => {
    const isBypass = shouldBypassLog(args);
    if (isBypass) {
        return;
    }

    consoleWarn(...args);
};
console.error = (...args) => {
    const isBypass = shouldBypassLog(args);
    if (isBypass) {
        return;
    }

    consoleError(...args);
};
console.info = (...args) => {
    const isBypass = shouldBypassLog(args);
    if (isBypass) {
        return;
    }

    consoleInfo(...args);
};
console.debug = (...args) => {
    const isBypass = shouldBypassLog(args);
    if (isBypass) {
        return;
    }

    consoleDebug(...args);
};
